// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import {changeWorkQueue} from "../../workQueueSlice";


// main function
export default function BulkEditContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleBulkEdit = () => {
        onMenuClose();
        console.log("Bulk Edit from action menu");
        dispatchData(changeWorkQueue({contractHeaderState: false, bulkEditGridState: true, actionMenuAction: "Bulk Edit",
            actionMenuState: false }));
    };



    return (

        <Box>
            {(
                (rowContractData.contractLevel === "Property" ||
                    rowContractData.contractLevel === "Labor Group" ||
                    rowContractData.contractLevel === "Guild" ||
                            rowContractData.contractLevel === "Option" ||
                            rowContractData.contractLevel === "Cast" ||
                            rowContractData.contractLevel === "Engagement")
                &&
                        (rowContractData.comboStatus !== "Approved" ||
                            rowContractData.comboStatus !== "Finalized")
                ) &&
                <MenuItem onClick={handleBulkEdit}>
                    <ListItemIcon>
                        <AutoAwesomeMotionIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Bulk Edit</ListItemText>
                </MenuItem>}
        </Box>

    )

}
